import type { IEntityOption, TEntityOption } from "utils/entityOptionType";

import { Record as ImmutableRecord } from "immutable";

export type TOnCallType = "Opsgenie" | "PagerDuty" | "ServiceNow" | "VictorOps";

const defaults = {
  id: "",
  isDeleted: false,
  membersCount: null as null | number,
  name: "",
  onCallIntegrationId: "",
  type: "" as TOnCallType,
};

export class OnCallIntegrationScheduleModel
  extends ImmutableRecord<typeof defaults>(defaults)
  implements IEntityOption<"OnCallIntegrationSchedule"> {
  static fromServerData(data: unknown) {
    const parsedData = data as typeof defaults;
    return new OnCallIntegrationScheduleModel(parsedData);
  }

  toEntityOption(): TEntityOption<"OnCallIntegrationSchedule"> {
    return {
      displayName: this.name,
      identifier: this.id,
      isDeleted: this.isDeleted,
      membersCount: this.membersCount,
      onCallScheduleType: this.type,
      type: "OnCallIntegrationSchedule",
    };
  }
}
